import React from 'react';
import {
  Box,
  Typography,
  Container,
  Link as MuiLink,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

const TermsAndConditions = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        background: 'rgba(18, 18, 18, 0.95)',
        minHeight: '100vh',
        color: 'white',
        pt: { xs: 10, sm: 12 },
        pb: 4,
      }}
    >
      <Container
        maxWidth="md"
        sx={{
          px: { xs: 2, sm: 3 },
          py: 4,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 300,
            mb: 2,
            letterSpacing: '0.05em',
            color: '#2196F3',
          }}
        >
          {t('terms.title')}
        </Typography>
        <Typography
          variant="body2"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.7)', mb: 2 }}
        >
          {t('terms.lastUpdated')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('terms.intro')}
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('terms.interpretationTitle')}
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: 300, mb: 1, color: 'rgba(255, 255, 255, 0.9)' }}
        >
          {t('terms.interpretation')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('terms.interpretationText')}
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: 300, mb: 1, color: 'rgba(255, 255, 255, 0.9)' }}
        >
          {t('terms.definitions')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 1 }}
        >
          {t('terms.definitionsIntro')}
        </Typography>
        <List sx={{ pl: 2, mb: 4, listStyleType: 'disc', display: 'list-item' }}>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('terms.definitionsAffiliateTerm')}</strong>{' '}
                  {t('terms.definitionsAffiliate')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('terms.definitionsCountryTerm')}</strong>{' '}
                  {t('terms.definitionsCountry')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('terms.definitionsCompanyTerm')}</strong>{' '}
                  {t('terms.definitionsCompany')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('terms.definitionsDeviceTerm')}</strong>{' '}
                  {t('terms.definitionsDevice')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('terms.definitionsServiceTerm')}</strong>{' '}
                  {t('terms.definitionsService')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('terms.definitionsTermsTerm')}</strong>{' '}
                  {t('terms.definitionsTerms')}
                  <MuiLink
                    href="https://www.privacypolicies.com/terms-conditions-generator/"
                    target="_blank"
                    rel="nofollow noopener"
                    sx={{ color: '#2196F3', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                  >
                    Terms and Conditions Generator
                  </MuiLink>
                  .
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('terms.definitionsThirdPartyTerm')}</strong>{' '}
                  {t('terms.definitionsThirdParty')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('terms.definitionsWebsiteTerm')}</strong>{' '}
                  {t('terms.definitionsWebsite')}
                  <MuiLink
                    href="https://aerocycling-project-front.onrender.com/"
                    target="_blank"
                    rel="external nofollow noopener"
                    sx={{ color: '#2196F3', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                  >
                    https://aerocycling-project-front.onrender.com/
                  </MuiLink>
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('terms.definitionsYouTerm')}</strong>{' '}
                  {t('terms.definitionsYou')}
                </Typography>
              }
            />
          </ListItem>
        </List>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('terms.acknowledgmentTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('terms.acknowledgment1')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('terms.acknowledgment2')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('terms.acknowledgment3')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('terms.acknowledgment4')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('terms.acknowledgment5')}
          <MuiLink
            component={RouterLink}
            to="/privacy-policy"
            sx={{ color: '#2196F3', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
          >
            {t('terms.privacyPolicy')}
          </MuiLink>
          .
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('terms.userRegistrationTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('terms.userRegistration')}
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('terms.dataStorageTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('terms.dataStorage')}
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('terms.linksTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('terms.links1')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('terms.links2')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('terms.links3')}
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('terms.terminationTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('terms.termination1')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('terms.termination2')}
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('terms.limitationTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('terms.limitation1')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('terms.limitation2')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('terms.limitation3')}
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('terms.disclaimerTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('terms.disclaimer1')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('terms.disclaimer2')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('terms.disclaimer3')}
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('terms.governingLawTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('terms.governingLaw')}
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('terms.disputesTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('terms.disputes')}
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('terms.euUsersTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('terms.euUsers')}
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('terms.usComplianceTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('terms.usCompliance')}
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('terms.severabilityWaiverTitle')}
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: 300, mb: 1, color: 'rgba(255, 255, 255, 0.9)' }}
        >
          {t('terms.severability')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('terms.severabilityText')}
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: 300, mb: 1, color: 'rgba(255, 255, 255, 0.9)' }}
        >
          {t('terms.waiver')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('terms.waiverText')}
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('terms.translationTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('terms.translation')}
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('terms.changesTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('terms.changes1')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('terms.changes2')}
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('terms.contactTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 1 }}
        >
          {t('terms.contactIntro')}
        </Typography>
        <List sx={{ pl: 2, mb: 4, listStyleType: 'disc', display: 'list-item' }}>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  {t('terms.contactEmail')}
                </Typography>
              }
            />
          </ListItem>
        </List>
      </Container>
    </Box>
  );
};

export default TermsAndConditions;